import { useIntl } from 'react-intl';

import messages from './messages';

import { ErrorButton, ErrorContainer, ErrorText } from './styles';
import AreaGraphErrorProps from './types';

const AreaGraphError = ({ handleError }: AreaGraphErrorProps): JSX.Element => {
  const { formatMessage } = useIntl();

  const errorButtonProps =
    typeof handleError === 'function'
      ? { onClick: handleError }
      : {
          href: handleError,
          onClick: e => {
            e.stopPropagation();
          },
        };

  return (
    <ErrorContainer>
      <ErrorText>{formatMessage(messages.error)}</ErrorText>
      <ErrorButton {...errorButtonProps}>{formatMessage(messages.errorButton)}</ErrorButton>
    </ErrorContainer>
  );
};

export default AreaGraphError;
